import { render, staticRenderFns } from "./QuestionPaper.vue?vue&type=template&id=293ae3f1&"
import script from "./QuestionPaper.vue?vue&type=script&lang=js&"
export * from "./QuestionPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports